"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const design_system_1 = require("@zapier/design-system");
const DropdownMenu_1 = __importDefault(require("./DropdownMenu"));
const common_components_1 = require("@zapier/common-components");
function AuthPicker(props) {
    const { auths, serviceKey, initialSelection, onConnect, onSelect } = props;
    const renderFloatingMenu = (menuProps) => {
        return (react_1.default.createElement(DropdownMenu_1.default, Object.assign({}, menuProps, { items: props.auths, onConnect: onConnect })));
    };
    const renderIcon = react_1.useCallback(() => (react_1.default.createElement(common_components_1.LogoImage, { app: serviceKey, backgroundType: "white", border: true, borderPadding: 4, borderRadius: 6, size: 20 })), [serviceKey]);
    const onBlur = (_e, meta) => {
        if (!meta.didBlurWithin) {
            meta.closeMenu();
        }
    };
    return (react_1.default.createElement(design_system_1.Dropdown, { initialSelectedItem: initialSelection, items: auths, onBlur: onBlur, onChange: onSelect, placeholder: "Choose an account\u2026", renderFloatingMenu: renderFloatingMenu, renderIcon: renderIcon }));
}
exports.default = AuthPicker;
